import modalTemplate from './view.html';
import { EmployeesDeleteModalController } from './controller';

class EmployeesDeleteModal {
    constructor($uibModal) {
        'ngInject';
        this.$uibModal = $uibModal;
        this.modalInstance = null;
    }

    $onInit = () => {
        this.$uibModal;
    };

    open = (selectedData) => {
        this.modalInstance = this.$uibModal.open({
            template: modalTemplate,
            bindToController: true,
            controller: EmployeesDeleteModalController,
            controllerAs: '$',
            size: 'nm',
            resolve: {
                selectedData: selectedData,
            },
            backdrop: 'static',
            keyboard: false,
        });

        return this.modalInstance.result;
    };
}

export {
    EmployeesDeleteModal,
    EmployeesDeleteModalController,
};
